export default "__VITE_ASSET__d7607ae4__"